export default __webpack_public_path__ + "static/media/trendingOrgIcon.8e0742c3.svg";